import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { UiSwitchComponent } from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

@Component({
  selector: 'app-switch-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiSwitchComponent, AppExampleSectionComponent],
  templateUrl: './switch-doc.component.html',
  styleUrl: './switch-doc.component.scss',
})
export class SwitchDocComponent {
  protected readonly notifications = signal(false);
  protected readonly darkMode = signal(true);
  protected readonly isInvalid = signal(false);
  protected readonly showErrorMsg = signal(true);

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }

  protected toggleErrorMsg(): void {
    this.showErrorMsg.update((v) => !v);
  }
}
